import React from 'react';

export const CustomIcon = () => {
    const clipPathId = 'clip0_3778_94';

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
            >
                <g clipPath={`url(#${clipPathId})`}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M14 1.93294L11.7457 0.830966C10.4037 0.174975 8.7833 0.701479 8.08321 2.02097L6.90716 4.23753L4.43566 4.67107C2.9644 4.92915 1.96295 6.30755 2.17214 7.78653L2.52356 10.271L0.778898 12.0745C-0.259677 13.1481 -0.25967 14.8518 0.778898 15.9254L2.52356 17.7289L2.17214 20.2134C1.96295 21.6924 2.9644 23.0708 4.43566 23.3288L6.90716 23.7624L8.08321 25.9789C8.78331 27.2985 10.4037 27.8249 11.7457 27.1689L14 26.067L16.2543 27.1689C17.5962 27.8249 19.2166 27.2985 19.9167 25.9789L21.0928 23.7624L23.5643 23.3288C25.0355 23.0708 26.037 21.6924 25.8278 20.2134L25.4764 17.7289L27.221 15.9254C28.2596 14.8518 28.2596 13.148 27.221 12.0745L25.4764 10.271L25.8278 7.78653C26.037 6.30757 25.0356 4.92915 23.5643 4.67107L21.0928 4.23753L19.9167 2.02097C19.2166 0.701469 17.5962 0.174979 16.2543 0.830966L14 1.93294Z"
                        fill="#F8F7FA"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M19.486 6.44919L17.6052 2.90435L14 4.66668L10.3948 2.90435L8.51402 6.44918L4.56148 7.14252L5.12348 11.1159L2.33334 14L5.12348 16.8842L4.56148 20.8575L8.51401 21.5508L10.3948 25.0957L14 23.3333L17.6052 25.0957L19.486 21.5508L23.4385 20.8575L22.8765 16.8842L25.6667 14L22.8765 11.1159L23.4385 7.14252L19.486 6.44919ZM8.16709 14.0297L9.66702 12.5298L12.3823 15.245L17.8696 9.7576L19.3696 11.2575L12.3823 18.2449L8.16709 14.0297Z"
                        fill="#FF5E30"
                    />
                </g>
                <defs>
                    <clipPath id={clipPathId}>
                        <path
                            d="M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z"
                            fill="white"
                        />
                    </clipPath>
                </defs>
            </svg>
        </div>
    );
};
